/* page-fathers-day.js — three progressive enhancements:
   1. Aspect-ratio observer: set --fd-*-ratio from the loaded images'
      natural dimensions so future image swaps with different ratios just
      work. (See CLAUDE_DESIGN_TO_SHOPIFY §6.)
   2. iOS Safari orientation reflow: force the grid to recompute track
      widths on portrait/landscape rotation. (See §11.)
   3. Header clearance observer: measure announce-bar + sticky header,
      cap at 160px, write --ngv-header-clearance for the section's
      padding-top calc. (See §7.)
   Step 2 is placed BEFORE step 3's early returns so it runs even on
   browsers without ResizeObserver. */
(function () {
  var root = document.getElementById('ngv-fathers-day');
  if (!root) return;

  /* 1. Aspect-ratio observer ------------------------------------- */
  function setRatioFromImg(selector, varName) {
    var img = root.querySelector(selector);
    if (!img) return;
    function apply() {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (w > 0 && h > 0) root.style.setProperty(varName, w + ' / ' + h);
    }
    if (img.complete && img.naturalWidth) apply();
    else img.addEventListener('load', apply, { once: true });
  }
  /* Hero is intentionally a fixed portrait frame (CSS fallback 4/5). The image
     is landscape but we want the man to fill the frame with sides cropped, per
     the owner's reference (2026-06-03). Do NOT add .hero-img back here. */
  setRatioFromImg('.product .frame .product-img', '--fd-prod-ratio');
  setRatioFromImg('.beforeafter .ba .ba-img', '--fd-ba-ratio');
  setRatioFromImg('.cat .cat-img', '--fd-cat-ratio');

  /* 2. iOS Safari orientation reflow ----------------------------- */
  function forceReflow() {
    var d = root.style.display;
    root.style.display = 'none';
    void root.offsetHeight;
    root.style.display = d || '';
  }
  function onOrientation() {
    setTimeout(forceReflow, 50);
    setTimeout(forceReflow, 300);
  }
  window.addEventListener('orientationchange', onOrientation);
  if (window.matchMedia) {
    var mq = window.matchMedia('(orientation: portrait)');
    if (mq.addEventListener) mq.addEventListener('change', onOrientation);
    else if (mq.addListener) mq.addListener(onOrientation);
  }

  /* 3. Header clearance observer --------------------------------- */
  if (!('ResizeObserver' in window)) return;
  var headerEls = [
    document.querySelector('.xo-announcement-bar'),
    document.querySelector('.xo-header__sticky')
  ].filter(Boolean);
  if (!headerEls.length) return;
  function updateClearance() {
    var total = 0;
    headerEls.forEach(function (el) {
      total += el.getBoundingClientRect().height;
    });
    if (total > 0) {
      var capped = total > 160 ? 160 : total;
      root.style.setProperty('--ngv-header-clearance', capped + 'px');
    }
  }
  var ro = new ResizeObserver(updateClearance);
  headerEls.forEach(function (el) { ro.observe(el); });
  updateClearance();
  if (document.readyState === 'complete') updateClearance();
  else window.addEventListener('load', updateClearance);
})();
